(() => {
  const ready = (fn) => document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn();
  const escapeHtml = (value = '') => String(value).replace(/[&<>"']/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]));

  ready(() => {
    const topStrip = document.querySelector('[data-topstrip]');
    const topStripClose = document.querySelector('[data-topstrip-close]');
    if (topStrip) topStrip.hidden = false;
    if (topStripClose) topStripClose.addEventListener('click', () => { if (topStrip) topStrip.hidden = true; });

    const header = document.querySelector('[data-header]');
    let scrollTimer;
    window.addEventListener('scroll', () => {
      if (!header) return;
      header.classList.add('is-scrolling');
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => header.classList.remove('is-scrolling'), 220);
    }, { passive: true });

    document.querySelectorAll('[data-mega-item]').forEach((item) => {
      const trigger = item.querySelector('[data-mega-trigger]');
      const open = () => { item.classList.add('is-open'); if (trigger) trigger.setAttribute('aria-expanded', 'true'); };
      const close = () => { item.classList.remove('is-open'); if (trigger) trigger.setAttribute('aria-expanded', 'false'); };
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', close);
      item.addEventListener('focusin', open);
      item.addEventListener('focusout', (event) => { if (!item.contains(event.relatedTarget)) close(); });
      item.addEventListener('keydown', (event) => { if (event.key === 'Escape') { close(); trigger && trigger.focus(); } });
    });

    const mobileMenu = document.querySelector('[data-mobile-menu]');
    const mobilePanel = document.querySelector('[data-mobile-panel]');
    const mobileOpen = document.querySelector('[data-mobile-open]');
    const mobileCloseButtons = document.querySelectorAll('[data-mobile-close]');
    const openMobile = () => {
      if (!mobileMenu) return;
      mobileMenu.hidden = false;
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(() => mobileMenu.classList.add('is-open'));
      if (mobileOpen) mobileOpen.setAttribute('aria-expanded', 'true');
      const firstFocusable = mobilePanel && mobilePanel.querySelector('button,a,input,summary');
      if (firstFocusable) firstFocusable.focus();
    };
    const closeMobile = () => {
      if (!mobileMenu) return;
      mobileMenu.classList.remove('is-open');
      document.body.style.overflow = '';
      if (mobileOpen) mobileOpen.setAttribute('aria-expanded', 'false');
      setTimeout(() => { mobileMenu.hidden = true; }, 280);
      if (mobileOpen) mobileOpen.focus();
    };
    if (mobileOpen) mobileOpen.addEventListener('click', openMobile);
    mobileCloseButtons.forEach((button) => button.addEventListener('click', closeMobile));
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && mobileMenu && !mobileMenu.hidden) closeMobile(); });

    const searchRoot = document.querySelector('[data-predictive-search]');
    if (!searchRoot) return;
    const input = searchRoot.querySelector('[data-search-input]');
    const results = searchRoot.querySelector('[data-search-results]');
    const i18n = {
      empty: searchRoot.dataset.i18nEmpty || 'No results',
      products: searchRoot.dataset.i18nProducts || 'Products',
      viewAll: searchRoot.dataset.i18nViewAll || 'View all results'
    };
    let timer;
    const hideResults = () => { if (results) { results.hidden = true; results.innerHTML = ''; } };
    const productImage = (product) => product.image || (product.featured_image && product.featured_image.url) || (product.featuredImage && product.featuredImage.url) || '';
    const renderResults = (products, query) => {
      if (!results) return;
      if (!products.length) {
        results.innerHTML = `<div class="cd13-search-empty">${escapeHtml(i18n.empty)}</div>`;
        results.hidden = false;
        return;
      }
      const items = products.slice(0, 6).map((product) => {
        const image = productImage(product);
        const url = product.url || `/products/${product.handle || ''}`;
        const sku = product.sku || (product.variants && product.variants[0] && product.variants[0].sku) || '';
        return `<a class="cd13-search-item" role="option" href="${escapeHtml(url)}"><span class="cd13-search-img">${image ? `<img src="${escapeHtml(image)}" alt="">` : '📦'}</span><span><strong>${escapeHtml(product.title)}</strong>${sku ? `<small>SKU : ${escapeHtml(sku)}</small>` : ''}</span></a>`;
      }).join('');
      results.innerHTML = `<div class="cd13-search-kicker">${escapeHtml(i18n.products)}</div>${items}<a class="cd13-search-all" href="/search?q=${encodeURIComponent(query)}&type=product">${escapeHtml(i18n.viewAll)}</a>`;
      results.hidden = false;
    };
    const search = async (query) => {
      try {
        const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`, { headers: { 'Accept': 'application/json' } });
        const data = await response.json();
        renderResults((data && data.resources && data.resources.results && data.resources.results.products) || [], query);
      } catch (error) {
        renderResults([], query);
      }
    };
    if (input) {
      input.addEventListener('input', () => {
        clearTimeout(timer);
        const query = input.value.trim();
        if (query.length < 2) { hideResults(); return; }
        timer = setTimeout(() => search(query), 150);
      });
      input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' && input.value.trim().length > 1) {
          event.preventDefault();
          window.location.href = `/search?q=${encodeURIComponent(input.value.trim())}&type=product`;
        }
      });
    }
    document.addEventListener('click', (event) => { if (!searchRoot.contains(event.target)) hideResults(); });
  });
})();